import { render, staticRenderFns } from "./DataColor.vue?vue&type=template&id=6a902bc6&scoped=true&"
import script from "./DataColor.vue?vue&type=script&lang=ts&"
export * from "./DataColor.vue?vue&type=script&lang=ts&"
import style0 from "./DataColor.vue?vue&type=style&index=0&id=6a902bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a902bc6",
  null
  
)

export default component.exports